/**
 * Dialog controller.
 *
 * This class controls site dialogs.
 */

/**
 * Export the class reference.
 */
export default class Dialog {

    /**
     * Add close event listener for all dialogs.
     *
     * @return {void}
     */
    events() {
        const dialogs = document.querySelectorAll( 'dialog' );
        dialogs.forEach( ( dialog ) => {
            dialog.addEventListener( 'click', this.closeDialog );
        } );
    }

    /**
     * Close dialog when clicked outside of it.
     *
     * @param {Event} event Click event.
     * @return {void}
     */
    closeDialog( event ) {
        if ( event.target === event.currentTarget ) {
            event.target.close();
        }
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.events();
    }
}
